export default "__VITE_ASSET__b125c2a5__"